import React from 'react';

const WalletButton = ({ 
  connected, 
  connecting, 
  account, 
  isOnBase, 
  onConnect, 
  onSwitchNetwork 
}) => {
  if (connecting) {
    return (
      <button
        disabled
        style={{
          background: 'rgba(255,255,255,0.1)',
          color: 'rgba(255,255,255,0.5)',
          padding: '12px 24px',
          borderRadius: '8px',
          border: '1px solid rgba(255,255,255,0.1)',
          fontWeight: '600',
          fontSize: '14px',
          cursor: 'wait',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <span style={{ 
          display: 'inline-block', 
          animation: 'spin 1s linear infinite',
          fontSize: '16px',
        }}>
          ⏳
        </span>
        Connecting...
      </button>
    );
  }

  if (connected && !isOnBase) {
    return (
      <button
        onClick={onSwitchNetwork}
        style={{
          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
          color: '#ffffff',
          padding: '12px 24px',
          borderRadius: '8px',
          border: 'none',
          fontWeight: '600',
          fontSize: '14px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          boxShadow: '0 4px 20px rgba(245, 158, 11, 0.3)',
          transition: 'all 0.2s ease',
        }}
      >
        <span style={{ fontSize: '16px' }}>⚠️</span>
        Switch to Base
      </button>
    );
  }

  if (connected) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
      }}>
        <div style={{
          background: 'rgba(34, 197, 94, 0.15)',
          border: '1px solid rgba(34, 197, 94, 0.3)',
          padding: '10px 16px',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}>
          <div style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            background: '#22c55e',
            boxShadow: '0 0 8px #22c55e',
          }} />
          <span style={{
            fontSize: '14px',
            fontWeight: '600',
            color: '#22c55e',
          }}>
            Base
          </span>
        </div>
        <div style={{
          background: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.1)',
          padding: '10px 16px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500',
          color: '#ffffff',
          fontFamily: 'monospace',
        }}>
          {account.slice(0, 6)}...{account.slice(-4)}
        </div>
      </div>
    );
  }

  return (
    <button
      onClick={onConnect}
      style={{
        background: 'linear-gradient(135deg, #0033A0 0%, #004494 100%)',
        color: '#ffffff',
        padding: '12px 24px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '600',
        fontSize: '14px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        boxShadow: '0 4px 20px rgba(0, 51, 160, 0.3)',
        transition: 'all 0.2s ease',
      }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
      Connect Wallet
    </button>
  );
};

export default WalletButton;
